var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VChat',{ref:"chat",attrs:{"options":_vm.chatOptions},on:{"update-chat":_vm.updateChat},scopedSlots:_vm._u([{key:"header",fn:function({ users }){return [_c('VDesignChatHeader',{attrs:{"participants-count":users.length,"title":_vm.task.name},on:{"goBackClick":_vm.closeChat}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }